import TrialBanner from '../trial-banner';
import Resources from './resources';

const ThankYou = () => (
  <div>
    <TrialBanner secondLineText='Your Avalara AvaTax API trial has been extended for 60 days' />
    <Resources />
  </div>
);

export default ThankYou;
